import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
} from "@mui/material"
import { FileText, CheckCircle, XCircle } from "lucide-react"
const textColor = "#0d2561"
const itextColor = "#707070"
export default function SubmittedRFPsStatusWidget() {
  const data = {
    proposalsReceived: 18,
    activeProposals: 10,
    noLongerActive: 8,
  }

  return (
    <Card>
      
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor, mb: 1, fontSize:'1.20rem' }}>
          Submitted RFPs Status
        </Typography>
        <Typography variant="body2" sx={{ color: itextColor, mb: 2 }}>
          Number of proposals received and their status (active/no longer active).
        </Typography>
        <Box mt={2} display="flex" flexDirection="column" gap={2}>
          <Box>
            <Box display="flex" alignItems="center" gap={2}>
              <FileText style={{width:'20px',height:'20px'}} />
              
              <Typography variant="h6" color="primary" sx={{ color: textColor,fontSize:'18px',fontWeight:'bold' }}>
                {data.proposalsReceived}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" ml={5}>
              Proposals Received
            </Typography>
          </Box>

          <Box>
            <Box display="flex" alignItems="center" gap={2}>
              <CheckCircle style={{ color: "#16a34a",fontWeight:600, width:'20px',height:'20px' }} />
              
              <Typography variant="h6" sx={{ color: "#16a34a",fontSize:'18px',fontWeight:'bold' }}>
                {data.activeProposals}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" ml={5}>
              Active Proposals
            </Typography>
          </Box>

          <Box sx={{marginBottom:'95px'}}>
            <Box display="flex" alignItems="center" gap={2}>
              <XCircle style={{ color: "#dc2626",fontWeight:600, width:'20px',height:'20px' }} />
             
              <Typography variant="h6" sx={{ color: "#dc2626",fontSize:'18px',fontWeight:'bold' }}>
                {data.noLongerActive}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" ml={5}>
              No Longer Active
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}
